import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { confirmationBackdropSx } from '@/shared/components/confirmation/confirmationModalStyles'
import { RiCloseLine } from '@/shared/icons/remix'

interface Props {
  open: boolean
  iframeSrc: string | null
  onClose: () => void
}

const TITLE = '#0D1B2A'
const CLOSE_BG = '#F4F7FA'

export function EkycIframeDialog({ open, iframeSrc, onClose }: Readonly<Props>) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      data-testid="ekyc-iframe-dialog"
      aria-labelledby="ekyc-iframe-title"
      slotProps={{
        backdrop: { sx: confirmationBackdropSx },
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: '14px',
          boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.18)',
          bgcolor: '#FFFFFF',
          overflow: 'hidden',
          m: 2,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.5,
          px: { xs: 2, sm: '24px' },
          pt: '18px',
          pb: '14px',
          borderBottom: '1px solid #EEF2F6',
          flexShrink: 0,
        }}
      >
        <Typography
          id="ekyc-iframe-title"
          component="h2"
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontWeight: 700,
            fontSize: '18px',
            lineHeight: '24px',
            color: TITLE,
            m: 0,
          }}
        >
          Identity verification
        </Typography>
        <IconButton
          aria-label="Close verification"
          onClick={onClose}
          data-testid="ekyc-iframe-close"
          disableRipple
          sx={{
            width: 30,
            height: 30,
            borderRadius: '8px',
            bgcolor: CLOSE_BG,
            color: TITLE,
            p: 0,
            flexShrink: 0,
            '&:hover': { bgcolor: '#E8EEF3' },
          }}
        >
          <RiCloseLine size={20} aria-hidden />
        </IconButton>
      </Box>

      {/* overflow hidden on the shell — only the iframe content scrolls */}
      <Box
        sx={{
          p: 0,
          height: { xs: '78vh', md: 760 },
          overflow: 'hidden',
          bgcolor: '#F5F7FA',
        }}
      >
        {iframeSrc ? (
          <Box
            component="iframe"
            title="iDenfy identity verification"
            src={iframeSrc}
            data-testid="ekyc-idenfy-iframe"
            sx={{
              display: 'block',
              width: '100%',
              height: '100%',
              border: 0,
            }}
            allow="camera https://ui.idenfy.com; microphone https://ui.idenfy.com; fullscreen; clipboard-write https://ui.idenfy.com"
            allowFullScreen
          />
        ) : null}
      </Box>
    </Dialog>
  )
}
